/**
 * What a picked / dropped file really is, judged from its first bytes — for the places that take a PHOTO from a file picker. The browser's
 * claimed type is only trusted when it names a normal image; an empty or generic type (phone file managers report that for HEIC) or a
 * ".heic" name proves nothing, so the bytes decide. The extension is never used.
 *
 * Reuses the Photo Booth's JPEG / PNG / WebP check (boothFiles.js) and adds the HEIC / HEIF container header.
 */
import { sniffBoothFile } from './boothFiles';

// ISO-BMFF `ftyp` major brands of HEIC / HEIF still images.
const HEIF_BRANDS = ['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'hevm', 'hevs', 'mif1', 'msf1', 'heif'];

/** 'image' (JPEG / PNG / WebP) | 'heic' (HEIC / HEIF) | null (anything else, a PDF included). */
export async function sniffPhotoFile(file) {
    if (!file || !file.size) return null;
    if ((await sniffBoothFile(file).catch(() => null)) === 'image') return 'image';
    const head = new Uint8Array(await file.slice(0, 12).arrayBuffer());
    const text = (from, to) => String.fromCharCode(...head.slice(from, to));
    return text(4, 8) === 'ftyp' && HEIF_BRANDS.includes(text(8, 12)) ? 'heic' : null;
}
